import React, {Component} from 'react';
import Header from "./header";
import TabsPage from "./components/tabs";
import katalog from './assets/img/newkatalog.mp4'

import carmen from './assets/img/carmen.png';
import dekor from './assets/img/dekor.png';
import delta from './assets/img/delta.png';
import fotokapak from './assets/img/fotokapak.png';
import siena from './assets/img/siena.png';
import * as images from './assets/img';
import Footer from "./footer";

class Home extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        let x = false;
        return (
            <div>
                <Header/>
                <main className="index">

                    <div className="main-container-top" id="video-container">
                        <video autoPlay loop muted>
                            <source src={katalog} type="video/mp4"/>
                            Your browser does not support HTML5 video.
                        </video>

                        <div className="text">
                            <div className="container">
                                <div className="text-container">
                                    <h1> Saydam Albüm </h1>
                                    <h4> " Her anınızda sizinleyiz.. " </h4>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="container">
                        <div className="main-container">

                            <div className="categories">
                                <div className="main-title-container">
                                    <h5 className="main-title">
                                        Hizmetlerimiz
                                    </h5>
                                </div>

                                <div className="accordian">
                                    <ul>
                                        <li>
                                            <div className="image_title">
                                                <a href="#"> Carmen </a>
                                            </div>
                                            <a href="#">
                                                <img src={carmen}/>
                                            </a>
                                        </li>
                                        <li>
                                            <div className="image_title">
                                                <a href="#"> Dekor </a>
                                            </div>
                                            <a href="#">
                                                <img src={dekor}/>
                                            </a>
                                        </li>
                                        <li>
                                            <div className="image_title">
                                                <a href="#"> Delta </a>
                                            </div>
                                            <a href="#">
                                                <img src={delta}/>
                                            </a>
                                        </li>
                                        <li>
                                            <div className="image_title">
                                                <a href="#"> Foto Kapak </a>
                                            </div>
                                            <a href="#">
                                                <img src={fotokapak}/>
                                            </a>
                                        </li>

                                        <li>
                                            <div className="image_title">
                                                <a href="#">Siena</a>
                                            </div>
                                            <a href="#">
                                                <img src={siena}/>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div className="boxes box-left">
                                <div className="boxes-container">
                                    <div className="picture-box">
                                        <img src={images.bella_plus} alt="Bella Plus"/>
                                    </div>

                                    <div className="description-box">
                                        <strong> Bella Plus </strong>
                                    </div>
                                </div>
                            </div>

                            <div className="boxes box-right">
                                <div className="boxes-container">
                                    <div className="description-box">
                                        <strong> Bella </strong>
                                    </div>

                                    <div className="picture-box">
                                        <img src={images.bella} alt="Bella Plus"/>
                                    </div>
                                </div>
                            </div>

                            <div className="boxes box-left">
                                <div className="boxes-container">
                                    <div className="picture-box">
                                        <img src={images.camel} alt="Camel"/>
                                    </div>

                                    <div className="description-box">
                                        <strong> Camel </strong>
                                    </div>
                                </div>
                            </div>

                            <div className="boxes box-right">
                                <div className="boxes-container">
                                    <div className="description-box">
                                        <strong> Elegance </strong>
                                    </div>

                                    <div className="picture-box">
                                        <img src={images.elegance} alt="Elegance" />
                                    </div>
                                </div>
                            </div>


                            <div className="boxes box-left">
                                <div className="boxes-container">
                                    <div className="picture-box">
                                        <img src={images.elizabeth} alt="elizabeth"/>
                                    </div>

                                    <div className="description-box">
                                        <strong> Elizabeth </strong>
                                    </div>
                                </div>
                            </div>

                            <div className="boxes box-right">
                                <div className="boxes-container">
                                    <div className="description-box">
                                        <strong> Emily </strong>
                                    </div>

                                    <div className="picture-box">
                                        <img src={images.emily} alt="Emily" />
                                    </div>
                                </div>
                            </div>


                            <div className="boxes box-left">
                                <div className="boxes-container">
                                    <div className="picture-box">
                                        <img src={images.even} alt="Even"/>
                                    </div>

                                    <div className="description-box">
                                        <strong> Even </strong>
                                    </div>
                                </div>
                            </div>

                            <div className="boxes box-right">
                                <div className="boxes-container">
                                    <div className="description-box">
                                        <strong> Flora </strong>
                                    </div>

                                    <div className="picture-box">
                                        <img src={images.flora} alt="Flora" />
                                    </div>
                                </div>
                            </div>

                            <div className="boxes box-left">
                                <div className="boxes-container">
                                    <div className="picture-box">
                                        <img src={images.fotokapak} alt="Foto Kapak"/>
                                    </div>

                                    <div className="description-box">
                                        <strong> Foto Kapak </strong>
                                    </div>
                                </div>
                            </div>

                            <div className="boxes box-right">
                                <div className="boxes-container">
                                    <div className="description-box">
                                        <strong> Leinen </strong>
                                    </div>

                                    <div className="picture-box">
                                        <img src={images.leinen} alt="Leinen" />
                                    </div>
                                </div>
                            </div>

                            <div className="boxes box-left">
                                <div className="boxes-container">
                                    <div className="picture-box">
                                        <img src={images.lima} alt="Lima"/>
                                    </div>

                                    <div className="description-box">
                                        <strong> Lima </strong>
                                    </div>
                                </div>
                            </div>

                            <div className="boxes box-right">
                                <div className="boxes-container">
                                    <div className="description-box">
                                        <strong> Liva </strong>
                                    </div>

                                    <div className="picture-box">
                                        <img src={images.liva} alt="Liva" />
                                    </div>
                                </div>
                            </div>

                            <div className="boxes box-left">
                                <div className="boxes-container">
                                    <div className="picture-box">
                                        <img src={images.lowra} alt="Lowra"/>
                                    </div>

                                    <div className="description-box">
                                        <strong> Lowra </strong>
                                    </div>
                                </div>
                            </div>

                            <div className="boxes box-right">
                                <div className="boxes-container">
                                    <div className="description-box">
                                        <strong> Luna Plus</strong>
                                    </div>

                                    <div className="picture-box">
                                        <img src={images.luna_plus} alt="Luna Plus" />
                                    </div>
                                </div>
                            </div>
                            
                            <div className="boxes box-left">
                                <div className="boxes-container">
                                    <div className="picture-box">
                                        <img src={images.luna} alt="Luna"/>
                                    </div>

                                    <div className="description-box">
                                        <strong> Luna </strong>
                                    </div>
                                </div>
                            </div>

                            <div className="boxes box-right">
                                <div className="boxes-container">
                                    <div className="description-box">
                                        <strong> Magneto </strong>
                                    </div>

                                    <div className="picture-box">
                                        <img src={images.magneto} alt="Megneto" />
                                    </div>
                                </div>
                            </div>

                                                        
                            <div className="boxes box-left">
                                <div className="boxes-container">
                                    <div className="picture-box">
                                        <img src={images.marvel} alt="Marvel"/>
                                    </div>

                                    <div className="description-box">
                                        <strong> Marvel </strong>
                                    </div>
                                </div>
                            </div>

                            <div className="boxes box-right">
                                <div className="boxes-container">
                                    <div className="description-box">
                                        <strong> Medusa </strong>
                                    </div>

                                    <div className="picture-box">
                                        <img src={images.medusa} alt="Medusa" />
                                    </div>
                                </div>
                            </div>

                                                                                    
                            <div className="boxes box-left">
                                <div className="boxes-container">
                                    <div className="picture-box">
                                        <img src={images.montana} alt="Montana"/>
                                    </div>

                                    <div className="description-box">
                                        <strong> Montana </strong>
                                    </div>
                                </div>
                            </div>

                            <div className="boxes box-right">
                                <div className="boxes-container">
                                    <div className="description-box">
                                        <strong> Nubuk </strong>
                                    </div>

                                    <div className="picture-box">
                                        <img src={images.nubuk} alt="Nubuk" />
                                    </div>
                                </div>
                            </div>

                                                                                                                
                            <div className="boxes box-left">
                                <div className="boxes-container">
                                    <div className="picture-box">
                                        <img src={images.rachel} alt="Rachel"/>
                                    </div>

                                    <div className="description-box">
                                        <strong> Rachel </strong>
                                    </div>
                                </div>
                            </div>

                            <div className="boxes box-right">
                                <div className="boxes-container">
                                    <div className="description-box">
                                        <strong> Reina </strong>
                                    </div>

                                    <div className="picture-box">
                                        <img src={images.reina} alt="Reina" />
                                    </div>
                                </div>
                            </div>

                                                                                                                                            
                            <div className="boxes box-left">
                                <div className="boxes-container">
                                    <div className="picture-box">
                                        <img src={images.ruby} alt="Ruby"/>
                                    </div>

                                    <div className="description-box">
                                        <strong> Ruby </strong>
                                    </div>
                                </div>
                            </div>

                            <div className="boxes box-right">
                                <div className="boxes-container">
                                    <div className="description-box">
                                        <strong> Saha </strong>
                                    </div>

                                    <div className="picture-box">
                                        <img src={images.saha} alt="Saha" />
                                    </div>
                                </div>
                            </div>

                                                                                                                                            
                            <div className="boxes box-left">
                                <div className="boxes-container">
                                    <div className="picture-box">
                                        <img src={images.september} alt="September"/>
                                    </div>

                                    <div className="description-box">
                                        <strong> September </strong>
                                    </div>
                                </div>
                            </div>

                            <div className="boxes box-right">
                                <div className="boxes-container">
                                    <div className="description-box">
                                        <strong> Sieana </strong>
                                    </div>

                                    <div className="picture-box">
                                        <img src={images.sieana} alt="Sieana" />
                                    </div>
                                </div>
                            </div>

                                                                                                                                                                        
                            <div className="boxes box-left">
                                <div className="boxes-container">
                                    <div className="picture-box">
                                        <img src={images.square} alt="Square"/>
                                    </div>

                                    <div className="description-box">
                                        <strong> Square </strong>
                                    </div>
                                </div>
                            </div>

                            <div className="boxes box-right">
                                <div className="boxes-container">
                                    <div className="description-box">
                                        <strong> Straw </strong>
                                    </div>

                                    <div className="picture-box">
                                        <img src={images.straw} alt="Straw" />
                                    </div>
                                </div>
                            </div>

                                                                                                                                                                        
                            <div className="boxes box-left">
                                <div className="boxes-container">
                                    <div className="picture-box">
                                        <img src={images.tokyo} alt="Tokyo"/>
                                    </div>

                                    <div className="description-box">
                                        <strong> Tokyo </strong>
                                    </div>
                                </div>
                            </div>

                            <div className="boxes box-right">
                                <div className="boxes-container">
                                    <div className="description-box">
                                        <strong> Velvet </strong>
                                    </div>

                                    <div className="picture-box">
                                        <img src={images.velvet} alt="Velvet" />
                                    </div>
                                </div>
                            </div>

                                                                                                                                                                        
                            <div className="boxes box-left">
                                <div className="boxes-container">
                                    <div className="picture-box">
                                        <img src={images.window_plus} alt="Window Plus"/>
                                    </div>

                                    <div className="description-box">
                                        <strong> Window Plus </strong>
                                    </div>
                                </div>
                            </div>

                            <div className="boxes box-right">
                                <div className="boxes-container">
                                    <div className="description-box">
                                        <strong> Window </strong>
                                    </div>

                                    <div className="picture-box">
                                        <img src={images.window} alt="Window" />
                                    </div>
                                </div>
                            </div>
                                                                                                                                                                        
                            <div className="boxes box-left">
                                <div className="boxes-container">
                                    <div className="picture-box">
                                        <img src={images.wood_plus} alt="Wood Plus"/>
                                    </div>

                                    <div className="description-box">
                                        <strong> Wood Plus </strong>
                                    </div>
                                </div>
                            </div>

                            <div className="boxes box-right">
                                <div className="boxes-container">
                                    <div className="description-box">
                                        <strong> Wood </strong>
                                    </div>

                                    <div className="picture-box">
                                        <img src={images.wood} alt="Wood" />
                                    </div>
                                </div>
                            </div>

                            <div className="boxes box-left">
                                <div className="boxes-container">
                                    <div className="picture-box">
                                        <img src={images.root} alt="Root"/>
                                    </div>

                                    <div className="description-box">
                                        <strong> Root </strong>
                                    </div>
                                </div>
                            </div>

                            <div className="boxes box-right">
                                <div className="boxes-container">
                                    <div className="description-box">
                                        <strong> Simple </strong>
                                    </div>

                                    <div className="picture-box">
                                        <img src={images.simple} alt="Simple" />
                                    </div>
                                </div>
                            </div>

                            <div className="boxes box-left">
                                <div className="boxes-container">
                                    <div className="picture-box sandık">
                                        <img src={images.sandik_1} alt="Sandık 1" style={{ marginBottom: 75, maxHeight: 400, width: 'auto' }} />
                                        <img src={images.sandik_2} alt="Sandık 2" />
                                    </div>

                                    <div className="description-box">
                                        <strong> Sandık </strong>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </main>

                <Footer/>
            </div>
        );
    }
}

export default Home;


// WEBPACK FOOTER //
// ./src/home.js